import { ComponentStyleConfig, ThemeComponents } from '@chakra-ui/react';

import {
  accordionStyleConfigs,
  actionButtonStyleConfigs,
  avatarStyleConfigs,
  buttonStyleConfigs,
  checkboxStyleConfigs,
  drawerBodyStyleConfigs,
  drawerCloseButtonStyleConfigs,
  drawerContentStyleConfigs,
  drawerHeaderStyleConfigs,
  drawerOverlayStyleConfigs,
  drawerStyleConfigs,
  formLabelStyleConfigs,
  headingStyleConfigs,
  inputStyleConfigs,
  linkStyleConfigs,
  modalHeaderBarStyleConfigs,
  modalOverlayStyleConfigs,
  modalStyleConfigs,
  progressStyleConfigs,
  radioStyleConfigs,
  selectStyleConfigs,
  skeletonStyleConfigs,
  spinnerStyleConfigs,
  textareaStyleConfigs,
  textStyleConfigs,
  tooltipStyleConfigs,
} from '../components';
/**
 * This module is separated from the rest of modules because of the following error:
 * Most likely, this error is caused by poor tree-shaking in the middleware build process (DEV build).
 * Compiling /src/middleware -> Error [TypeError]: Cannot read properties of undefined (reading 'iconStyleConfigs')
 */
import { iconStyleConfigs } from '../components/icon';
import { ThemeName } from '../types/theme-name';
import { hasProperty } from './has-property';

const componentStyleConfigs: Record<
  string,
  Record<ThemeName | string, ComponentStyleConfig>
> = {
  Accordion: accordionStyleConfigs,
  ActionButton: actionButtonStyleConfigs,
  Avatar: avatarStyleConfigs,
  Button: buttonStyleConfigs,
  Checkbox: checkboxStyleConfigs,
  Drawer: drawerStyleConfigs,
  DrawerBody: drawerBodyStyleConfigs,
  DrawerCloseButton: drawerCloseButtonStyleConfigs,
  DrawerContent: drawerContentStyleConfigs,
  DrawerHeader: drawerHeaderStyleConfigs,
  DrawerOverlay: drawerOverlayStyleConfigs,
  FormLabel: formLabelStyleConfigs,
  Link: linkStyleConfigs,
  Heading: headingStyleConfigs,
  Icon: iconStyleConfigs,
  Input: inputStyleConfigs,
  Modal: modalStyleConfigs,
  ModalHeaderBar: modalHeaderBarStyleConfigs,
  ModalOverlay: modalOverlayStyleConfigs,
  Progress: progressStyleConfigs,
  Radio: radioStyleConfigs,
  Select: selectStyleConfigs,
  Skeleton: skeletonStyleConfigs,
  Spinner: spinnerStyleConfigs,
  Text: textStyleConfigs,
  Textarea: textareaStyleConfigs,
  Tooltip: tooltipStyleConfigs,
};

export const getComponentStyleConfigs = (
  components: string[],
  themeName: ThemeName
): ThemeComponents => {
  const styleConfigs: ThemeComponents = {};
  components.forEach((componentName) => {
    if (
      hasProperty(componentStyleConfigs, componentName) &&
      hasProperty(componentStyleConfigs[componentName], themeName)
    ) {
      styleConfigs[componentName] =
        componentStyleConfigs[componentName][themeName];
    }
  });
  return styleConfigs;
};
